import * as React from "react";
const SvgEllipses = props => <svg xmlns="http://www.w3.org/2000/svg" width={10} height={10} fill="none" viewBox="0 0 10 10" {...props}><circle cx={5} cy={5} r={4} fill="#FF754C" stroke="#fff" strokeWidth={2} /></svg>;
export default SvgEllipses;